import styled from "styled-components";

export const StyledLoading = styled.div`
  .loading-container {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #00000030;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column nowrap;
    gap: 12px;
    z-index: 100;

    .loading-circle {
      width: 60px;
      height: 60px;
      border: 12px solid #fafafa;
      border-radius: 50%;
      border-top: 12px solid #4679cc;
      animation: loading 1.6s linear infinite;
    }

    .loading-message {
      font-size: 18px;
      font-weight: 900;
      color: #fff;
    }
  }

  @keyframes loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
